import React from 'react';
import { motion } from 'framer-motion';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="bg-blue-900 py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-51" data-mp="ounbyzutcaqa">
      <div className="mx-auto max-w-4xl px-4" data-id="element-52" data-mp="12tmzg46lajkv">
        <div className="text-center" data-id="element-53" data-mp="xtqua1m5om3q">
          <h2 id="closing-title" className="text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-54" data-mp="xspifuxbfvky">
            Next Monday you can keep improvising…
          </h2>
          <p className="metal-silver-text mt-4 text-2xl font-extrabold sm:text-3xl" data-id="element-55" data-mp="17sgew25fskno">
            Or you can enter your classroom fully prepared starting today.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-56" data-mp="1hhzyxb4vykk4">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-lg border-l-4 border-slate-300 bg-blue-950/60 px-4 py-3 text-sm font-semibold text-white" data-id="element-57" data-mp="1vgzn6hohkxfr" data-mpi={index}>
              <span className="text-slate-300" aria-hidden="true" data-id="element-58" data-mp="2c8yu5jl0a26q">
                ▸
              </span>
              {line}
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-59" data-mp="2la6qhw3yosy6">
          <p className="leading-relaxed text-slate-300" data-id="element-60" data-mp="2qab7dn8s7pox">
            This teacher ready won't make you a better educator. You're already an excellent educator.
          </p>
          <p className="mt-3 text-lg font-bold text-white" data-id="element-61" data-mp="2v34daefzl42l">
            What this teacher ready does is give you the time and tools so that excellence shows in every single class.
          </p>
        </div>
      </div>
    </section>;
}